import { useMemo } from "react";

import { useGetRolesList } from "../../hooks";

export const useRolesHookFormList = ({ locationId }) => {
  const { data, isLoading, isSuccess } = useGetRolesList({ locationId });

  const roles = useMemo(() => {
    if (!data) return [];
    return locationId ? data.filter((u) => u.locationId === locationId) : data;
  }, [data, locationId]);

  return { roles, isLoading, isSuccess };
};
